<span container="body" [ngbTooltip]="tooltip()">
  <div class="layout-row layout-align-start-center full-height">
    <bz-icon class="packages-icon margin-right-5" [icon]="icon"></bz-icon>
    <span class="md-tiny">{{ packagesCount() }}</span>
  </div>
</span>
